import { TermsOfService } from "@project-mgmt/ui";

export function TermsPage() {
  return <TermsOfService />;
}
